// Minimum sane rate (₦) per billing period. Mirrors
// tutorslinks-backend/utils/rateThresholds.js — used to warn a tutor/centre
// before they submit an unusually low rate (e.g. ₦10/hour, ₦80/month). The
// backend re-checks and flags the profile for admin review regardless of
// what happens here, so this is a UX nudge, not the source of truth.
export const MIN_RATE_THRESHOLDS = {
  hour: 500,
  day: 1500,
  week: 3000,
  month: 3000,
  session: 500,
  term: 8000,
};

const PERIOD_LABELS = {
  hour: "hour",
  day: "day",
  week: "week",
  month: "month",
  session: "session",
  term: "term",
};

// Returns a warning string if the rate looks unusually low for its period,
// or null if it's fine / can't be checked yet.
export const checkUnusualRate = (rate, period) => {
  const num = Number(rate);
  const min = MIN_RATE_THRESHOLDS[period];
  if (!num || !min || !(num > 0)) return null;
  if (num < min) {
    return `₦${num} per ${PERIOD_LABELS[period] || period} looks unusually low (most listings start around ₦${min}). Continue anyway?`;
  }
  return null;
};

// Scans a categoryDetails object ({ [group]: { rate, period } }) and returns
// an array of warning strings, one per unusual rate found.
export const findUnusualRateWarnings = (categoryDetails = {}) => {
  const warnings = [];
  Object.entries(categoryDetails || {}).forEach(([group, detail]) => {
    const warning = checkUnusualRate(detail?.rate, detail?.period || "hour");
    if (warning) warnings.push(`${group} — ${warning}`);
  });
  return warnings;
};
